import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import Pending from "../components/vouchers/pending";
import New from "../components/vouchers/new";

function NewVoucherView() {
  return (
    <Container fluid className="main-content-container px-4 pb-1">
      <Row>
        <Col md="12">
          <New />
        </Col>
      </Row>
    </Container>
  );
}

export default NewVoucherView;
